const eventList = document.querySelector('.event-module');

if (eventList) {
  const setUniformEventDateWidth = () => {
    const eventModules = document.querySelectorAll('.event-module');

    eventModules.forEach((module) => {
      const dateWrappers = module.querySelectorAll('.event-module__date-wrapper');
      const maxWidth = Math.floor(Math.max(...Array.from(dateWrappers, (date) => date.getBoundingClientRect().width)));

      dateWrappers.forEach((date) => {
        date.style.width = `${maxWidth}px`;
      });
    });
  };

  const axiosGetEventList = async (parent, pageNumber) => {
    const order = parent.querySelector('[data-order]').value;
    const type = parent.querySelector('[data-type]').value;
    const listInner = parent.querySelector('.event-module__list-inner');
    const noResultElem = parent.querySelector('.event-module__not-found');
    const eventListFooter = parent.querySelector('.event-module__footer');

    const formDataInput = {
      action: 'getEventsListPosts',
      order,
      type,
      pageNumber,
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      listInner.innerHTML = '';

      if (listInner && data.data.html_list) {
        listInner.innerHTML = data.data.html_list;
        noResultElem.classList.add('hide');

        setUniformEventDateWidth();
      }

      if (noResultElem && !data.data.html_list) {
        noResultElem.classList.remove('hide');
      }

      if (eventListFooter && data.data.html_pagination) {
        eventListFooter.innerHTML = data.data.html_pagination;
      }

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['pageNumber']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
    } catch (err) {
      console.error(err);
    }
  };

  // Pagination
  attachEvent('.event-module .pagination .pagination__number', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.event-module');
    const pageNumber = ev.target.dataset.page;

    axiosGetEventList(parent, pageNumber);
  });

  document.addEventListener('DOMContentLoaded', () => {
    setUniformEventDateWidth();
    window.addEventListener('resize', debounce(setUniformEventDateWidth, 200));
  });
}
